/* Homepage V2 design tokens + tiny helpers (Figma 47:2 foundations). */
export const V2 = {
  bg: "#000000",
  panel: "#0a0a10",
  panelDeep: "#0e0e16",
  border: "#222234",
  border2: "#242432",
  text: "#f7f7fa",
  body: "#b8bac7",
  body2: "#b9b9c7",
  muted: "#9696a8",
  metaMuted: "#7b8093",
  faint: "#66667a",
  violet: "#8b5cff",
  violetCta: "#6f2cf4",
  cyan: "#22d3ee",
  cyan2: "#23d7ff",
  green: "#34d6ad",
  green2: "#42e8b4",
  pos: "#39e58c",
  blue: "#5d9bff",
  blue2: "#5b93ff",
  red: "#f0445e",
  neg: "#ff4d67",
};

export const timeAgo = (iso?: string | null): string => {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const ageMinutes = (iso?: string | null): number | null => {
  if (!iso) return null;
  return Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
};

export const ageSeconds = (iso?: string | null): number | null => {
  if (!iso) return null;
  return Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
};

export const fmtBig = (n?: number | null): string => {
  if (n == null) return "—";
  if (n >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
  if (n >= 1e9) return `$${(n / 1e9).toFixed(1)}B`;
  if (n >= 1e6) return `$${(n / 1e6).toFixed(1)}M`;
  return `$${Math.round(n).toLocaleString()}`;
};

export const fmtPrice = (n?: number | null): string => {
  if (n == null) return "—";
  return `$${n >= 1000 ? Math.round(n).toLocaleString() : n.toFixed(2)}`;
};

export const fmtChange = (n?: number | null): string => {
  if (n == null) return "—";
  return `${n >= 0 ? "+" : "−"}${Math.abs(n).toFixed(2)}%`;
};

export const changeColor = (n?: number | null): string =>
  n == null ? V2.muted : n >= 0 ? V2.pos : V2.neg;
